import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLeadInquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BACKEND_URL}/api/admin/lead-inquiries`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { page: 1, limit: 100 },
        });
        setInquiries(res.data.inquiries || []);
        setTotal(res.data.total || 0);
      } catch (err) {
        setError(err.response?.data?.detail || "Failed to load inquiries");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div data-testid="admin-lead-inquiries">
      <h1 className="font-heading text-2xl font-bold mb-2">Lead Inquiries</h1>
      <p className="text-[#9CA3AF] text-sm mb-6">{total} total</p>

      {error && <p className="text-red-400 mb-4">{error}</p>}
      {loading ? (
        <p className="text-[#9CA3AF]">Loading…</p>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-white/10">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/10 text-left text-[#9CA3AF]">
                <th className="px-4 py-3 font-medium">Date</th>
                <th className="px-4 py-3 font-medium">Name</th>
                <th className="px-4 py-3 font-medium">Email</th>
                <th className="px-4 py-3 font-medium">Industry</th>
                <th className="px-4 py-3 font-medium">Inbound/mo</th>
                <th className="px-4 py-3 font-medium">Channel</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.map((row) => (
                <tr key={row.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 text-[#9CA3AF] whitespace-nowrap">
                    {new Date(row.created_at).toLocaleString()}
                  </td>
                  <td className="px-4 py-3">{row.name}</td>
                  <td className="px-4 py-3">
                    <a href={`mailto:${row.email}`} className="text-[#00D1FF] hover:underline">
                      {row.email}
                    </a>
                  </td>
                  <td className="px-4 py-3">{row.industry}</td>
                  <td className="px-4 py-3">{row.monthly_inbound}</td>
                  <td className="px-4 py-3">{row.primary_channel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminLeadInquiries;
